import {
  useReducer,
  createContext,
  useContext,
  useEffect,
  FC,
  ReactNode,
} from 'react';
import {
  recorderReducer,
  RecorderState,
  initialState,
} from './recorderReducer';

export const RecorderContext = createContext<RecorderState | undefined>(
  undefined
);

export const RecorderProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const init = (initialValue = initialState) => {
    if (typeof window !== 'undefined') {
      const localState = JSON.parse(
        localStorage.getItem('recorderState') as string
      ) as Partial<RecorderState>;
      return { ...initialValue, ...localState };
    }
    return initialValue;
  };

  const [state, dispatch] = useReducer<
    (state: RecorderState, action: any) => RecorderState,
    RecorderState
  >(recorderReducer, initialState, init);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const {
        devices: { videoDevice, audioDevice },
        mediaPermission,
      } = state;
      localStorage.setItem(
        'recorderState',
        JSON.stringify({
          devices: { videoDevice, audioDevice },
          mediaPermission,
        })
      );
    }
  }, [state]);

  return (
    <RecorderContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </RecorderContext.Provider>
  );
};

export const useRecorderContext = () => {
  const context = useContext(RecorderContext);
  if (!context) {
    throw new Error(
      'Recorder components cannot be rendered outside the RecorderProvider component'
    );
  }
  return context;
};
